import { render, staticRenderFns } from "./PivotTable.vue?vue&type=template&id=47d8a226"
import script from "./PivotTable.vue?vue&type=script&lang=js"
export * from "./PivotTable.vue?vue&type=script&lang=js"
import style0 from "./PivotTable.vue?vue&type=style&index=0&id=47d8a226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports